import { Suspense, type PropsWithChildren } from 'react'

import { PageLayoutSkeleton } from '@/layouts/page'

export const CadastrarClienteAtendimentoPageSuspense = ({ children }: PropsWithChildren) => {
  return <Suspense fallback={<PageLayoutSkeleton />}>{children}</Suspense>
}
